import * as React from 'react';
import { useCopilotMessage_unstable } from './useCopilotMessage';
import { renderCopilotMessage_unstable } from './renderCopilotMessage';
import { useCopilotMessageStyles_unstable } from './useCopilotMessageStyles';
// CopilotMessage component - TODO: add more docs
export const CopilotMessage = /*#__PURE__*/React.forwardRef((props, ref) => {
  const state = useCopilotMessage_unstable(props, ref);
  useCopilotMessageStyles_unstable(state);
  return renderCopilotMessage_unstable(state);
});
CopilotMessage.displayName = 'CopilotMessage';
//# sourceMappingURL=CopilotMessage.js.map